
import '../App.css';
import React, {useState, useEffect, use} from 'react';
import { useParams } from 'react-router-dom';





// Applications 
import SRT_Archangels_LO from '../components/Applications/SRT_Archangels_LO.jsx';

function ApplicationCenter() {

 
    const applicationId = useParams().applicationId;
    console.log("Application ID:", applicationId);
    
  return (
    <>
      {applicationId === undefined && (
        <>
          <br />
          <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
              <hr class="my-2" />
              <h2>Application</h2>
              <h2>Center</h2>
              <hr class="my-4" />
          </div>
          <p style={{margin: "auto", textAlign: "center"}}>This link is invalid.</p><p style={{margin: "auto", textAlign: "center"}}>☹️</p><br />
          <button className="btn btn-primary" style={{margin: "auto", display: "block"}} onClick={() => window.location.href = "/"}>Go back</button>
        </>
      )} 

      {applicationId === "SRT_Archangels_LO" && (
        <SRT_Archangels_LO />
      )} 
        
      
    </>
  );
}

export default ApplicationCenter;
